/* @flow */

import { type Pedido } from './types';
import { type Contato } from '../usuario/types';

const filtroTelefone = (termoTelefone: RegExp) => (contato: Contato) => termoTelefone
    .test(contato.numero) || termoTelefone.test(`${contato.ddd}${contato.numero}`);

const filtrarPedidosPorTermoPesquisa = (termoPesquisa: ?string) => {
    if (!termoPesquisa) {
        return () => true;
    }

    const regexNome = new RegExp(`^${termoPesquisa}`, 'i');
    const regexpTelefone = new RegExp(termoPesquisa.replace(/\D/, ''));

    return ({ usuario, id }: Pedido): boolean => {
        if (termoPesquisa === `${id}`) {
            return true;
        }

        if (!usuario) {
            return false;
        }

        if (regexNome.test(usuario.nome)) {
            return true;
        }

        return !!usuario.contatos.find(filtroTelefone(regexpTelefone));
    };
};

export default filtrarPedidosPorTermoPesquisa;
